import React, { useState } from 'react';

const TeamDeleteModal = ({ show, team, onCancel, onConfirm, loading, error, styles }) => {
  const [confirmText, setConfirmText] = useState('');

  if (!show) return null;

  const handleConfirm = () => {
    onConfirm(confirmText);
  };

  return (
    <div style={styles.modalOverlay} onClick={onCancel}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h2 style={styles.modalTitle}>Delete Team</h2>
        <p style={styles.modalText}>
          Are you sure you want to delete <strong>{team?.name}</strong>?
        </p>
        <p style={styles.modalWarning}>
          ⚠️ This will permanently delete the team and remove all coach assignments. Players
          assigned to this team will be unassigned.
        </p>
        <div style={styles.formGroup}>
          <label style={styles.label}>Type "yes, delete team" to confirm:</label>
          <input
            type="text"
            style={styles.input}
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder="yes, delete team"
          />
        </div>
        {error && <div style={styles.error}>{error}</div>}
        <div style={styles.modalActions}>
          <button style={{ ...styles.button, ...styles.secondaryButton }} onClick={onCancel}>
            Cancel
          </button>
          <button
            style={{ ...styles.button, ...styles.dangerButton }}
            onClick={handleConfirm}
            disabled={loading || confirmText !== 'yes, delete team'}
          >
            {loading ? 'Deleting...' : 'Delete Team'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeamDeleteModal;
